import React from "react";
import SingOutSVG from "assets/svg/signout";
import VerifyIconXSVG from "assets/svg/verified-icon-xs";
import UsersIconSVG from "assets/svg/users";
import ProfileDefault from "assets/images/profile_default.png";   
import { display_name, currentLang } from "utils/utils";
import { useTranslation } from "react-i18next";

export default function HeaderProfileDetails({
  userData = {},
  occupation = "",
  handleLogout = () => { },
  editAccount = () => { },
  myProfile = ()=>{},
  profiles = [],
}) {
  const {t} = useTranslation();
  const lang = currentLang();
  const {translation=null, profile_name=null, other_name=null} = userData?.profile || {};
  return (
    <div className="bg-white px-2 py-2">
      <div className="relative w-full flex items-center gap-x-5 bg-white px-6 py-4 rounded-md cursor-pointer hover:bg-modalGray" onClick={myProfile}> 
        <div className="flex items-center gap-2">
          <div className="w-22 5sm:w-24.5 bg-passwordGray rounded-lg">
            <img
              src={userData.profile?.profile_image_webp_url || userData.profile?.profile_image_url || ProfileDefault}
              alt="milestone-profile"
              className="rounded-md w-22 5sm:w-24.5"
            />
          </div>
        </div>
        <div className="w-15/20">
          <p className="text-lightBlack font-bold text-lg leading-5.5 tracking-tighter flex items-center">
            <>
              {/* {userData?.profile?.profile_name || userData?.profile?.other_name || userData?.user?.username} */}
             {(translation?.[lang]?.[profile_name] || userData?.profile?.profile_name) ||
                        (translation?.[lang]?.[other_name] || userData?.profile?.other_name) || 
                        (translation?.[lang]?.[userData?.user?.username] || userData?.user?.username) }
              {/* {userData?.profile?.username ||
              userData?.user?.username ||
                userData?.profile?.other_name ||
                (userData?.user.email ? userData?.user.email?.split("@")[0] : "")} */}
            </>
            {userData.profile.id3_verified && (
              <VerifyIconXSVG className="ml-2" />
            )}
          </p>
          <p className="text-darkerGray text-xs leading-4.5">{occupation}</p>
          { (userData.profile?.display_count || 0) > 0 &&
            <p className="text-darkerGray text-xs leading-4.5 flex items-center">
              <UsersIconSVG className="mr-2" />
              <>{userData.profile?.display_count || 0} {(userData.profile?.display_count || 0) < 2 ? t('users') : 'Users'}</>
            </p>
          }
          {/*  */}
          <div className="w-full mt-2.5 1xs:flex 1xs:justify-between">
            <button
              className="text-sm text-primary font-semibold leading-4.4 hover:text-lightPrimary"
              onClick={(e)=>{
                e.stopPropagation();
                editAccount();
              }}
            >
              {t('editAccount')}
            </button>
            <button
              className="text-sm text-lightBlack font-semibold leading-4.4 flex items-center hover:text-darkPrimary"
              onClick={(e)=>{
                e.stopPropagation();
                handleLogout();
              }}
            >
              <SingOutSVG className="mr-2" />
              <>{t('singOutAccount')}</>
            </button>
          </div> 
      </div>
    </div>
    </div>
  );
}
